import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import ApiService from "../../services/ApiService";

const Login = () => {
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // Use ApiService for login
      const userData = await ApiService.login(credentials);

      // Use the auth context login method
      login(userData);

      // Redirect based on role
      if (userData.role === "admin") {
        navigate("/admin/users");
      } else {
        navigate("/fax/send");
      }
    } catch (err) {
      setError("Login failed. Incorrect Password or Email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-container">
      <div className="h-100 d-flex bg-premium-dark justify-content-center align-items-center">
        <div className="mx-auto app-login-box col-md-4 col-lg-3">
          <div className="mx-auto mb-3 text-center">
            <img
              src={require("../../assets/utils/images/Talkloop .png")}
              alt="Talkloop"
              style={{ height: "80px", width: "auto" }}
            />
          </div>
          <Card className="mx-auto my-auto" style={{ maxWidth: "400px" }}>
            <CardHeader className="text-center">
              <h4 className="mb-0">Login</h4>
            </CardHeader>
            <CardBody>
              {error && <Alert color="danger">{error}</Alert>}
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Label for="username">Email</Label>
                  <Input
                    type="text"
                    name="username"
                    id="username"
                    value={credentials.username}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="password">Password</Label>
                  <Input
                    type="password"
                    name="password"
                    id="password"
                    value={credentials.password}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
                <Button
                  color="primary"
                  size="lg"
                  block
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "Sign In"}
                </Button>
              </Form>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Login;
